<template>
  <div id="home">
    <headerbom></headerbom>
    <div class="home-banner-kuan">
      <div class="home-banner">
        <!-- <h1>
        让数据更懂你</br>
        让推广更简单
      </h1>
      <img src="../img/home1.png" alt=""> -->
        <video-player ref="videoPlayer" :options="playerOptions"></video-player>
      </div>
    </div>
    <div class="title_box">
      <h1>业务生态</h1>
      <p>专注移动营销数据赋能，探索效果领域无限可能</p>
    </div>
    <ul class="home_introduce">
      <li>
        <img src="../img/home2.png" alt="">
        <section>
          <h2>巨掌ASO</h2>
          <p>苹果应用商店优化：App store opetimization，简称“ASO”，即优化关键词覆盖排名等。</p>
        </section>
      </li>
      <li>
        <section>
          <h2>巨掌ASA</h2>
          <p>苹果应用商店搜索市场：App Store Search Marketing，简称ASM；苹果官方又称为Search Ads，简称ASA。</p>
        </section>
        <img src="../img/home3.png" alt="" style="margin: 0 0 0 0.4rem">
      </li>
      <li>
        <img src="../img/home4.png" alt="">
        <section>
          <h2>游戏SaaS</h2>
          <p>休闲式场景营销，帮助互联网企业提升运营效果，提升变现效率，帮助广告主提高转化效果，不断提升用户体验，实现三方共赢。</p>
        </section>
      </li>
    </ul>
    <div class="title_box">
      <h1>最新动态</h1>
      <p>公司实时动态，行业最新资讯，一手掌握</p>
    </div>
    <div class="home_news">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div>
            <img src="../img/home5.png" alt="">
          </div>
          <h1>
            企业动态
            <span @click="tonews(0)">查看更多></span>
          </h1>
          <ul>
            <li v-for="(ele,index) in newslist1" :key="index" v-if="index<5">
              <p><a :href="ele.jumpLink">{{ele.title}}</a></p>
              <span>{{ele.editTime.substring(0,10)}}</span>
            </li>
          </ul>
        </van-swipe-item>
        <van-swipe-item>
          <div>
            <img src="../img/home6.jpg" alt="">
          </div>
          <h1>
            行业动态
            <span @click="tonews(1)">查看更多></span>
          </h1>
          <ul>
            <li v-for="(ele,index) in newslist2" :key="index" v-if="index<5">
              <p><a :href="ele.jumpLink">{{ele.title}}</a></p>
              <span>{{ele.editTime.substring(0,10)}}</span>
            </li>
          </ul>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="title_box">
      <h1>合作伙伴</h1>
      <p>累计服务超过2000家企业和应用开发者，拥有一批互信共赢的头部企业</p>
    </div>
    <div class="home_friend">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{noleft: index % 3 == 0}">
          <img :src="ele" alt="">
        </div>
      </section>
    </div>
    <div class="home_fr_mo" @click="tofriend">
      查看更多
      <i class="iconfont iconxia"></i>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "",
            src: "https://static.adjuz.net/adjuz-website/m_adjuzmv1.mp4",
          },
        ],
        poster: require("../img/home1.png"),
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false,
        },
      },
      newslist1: [],
      newslist2: [],
      frlist: [
        require("../img/home7.png"),
        require("../img/home8.png"),
        require("../img/home9.png"),
        require("../img/home10.png"),
        require("../img/home11.png"),
        require("../img/home12.png"),
        require("../img/home13.png"),
        require("../img/home14.png"),
        require("../img/home15.png"),
      ],
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() {
    // setTimeout(() => {
    //   this.$refs.videoPlayer.player.play();
    // }, 3000);
    this.GetNewsInfoList()
  },
  methods: {
    tofriend() {
      window.open(this.$router.resolve({ path: "/friend" }).href, "_blank");
    },
    tonews(num) {
      if (num == 1) {
        window.open(this.$router.resolve({ path: "/news" }).href, "_blank");
      } else {
        window.open(
          this.$router.resolve({ path: "/news", query: { type: "enterprise" } })
            .href,
          "_blank"
        );
      }
    },
    /**获取列表 */
    GetNewsInfoList() {
      let url = "https://api.asa.adjz.com/api/Tool/GetNewsInfoList";
      this.$https.get(url).then((res) => {
        res.data.map(ele => {
          if (ele.tagsName.indexOf('企业动态') != -1) {
            this.newslist1.push(ele)
          } else {
            this.newslist2.push(ele)
          }
        })
      });
    },
  },
};
</script>

<style lang="less" scoped>
#home {
  padding-top: 1rem;
  .home-banner-kuan {
    min-height: 4.24rem;
    background: url("../img/home1.png") no-repeat center center;
    background-size: cover;
  }
  .home-banner {
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    h1 {
      font-size: 0.44rem;
      position: absolute;
      left: 0.3rem;
      color: #fff;
      top: 45%;
      transform: translateY(-50%);
      line-height: 0.8rem;
      letter-spacing: 0.02rem;
    }
  }
  .title_box {
    width: 100%;
    height: 2.5rem;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0.3rem;
    h1 {
      font-size: 0.36rem;
      font-weight: bold;
      columns: #333;
      margin: 0.86rem 0 0.26rem;
    }
    p {
      font-size: 0.28rem;
      color: #666;
    }
  }
  .home_introduce {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.22rem;
    li {
      border: 0.01rem solid #dcdfe6;
      border-radius: 0.12rem;
      box-sizing: border-box;
      padding: 0.34rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.3rem;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 1.3rem;
        height: auto;
        flex-shrink: 0;
        margin-right: 0.4rem;
      }
      h2 {
        font-size: 0.32rem;
        color: #333;
        font-weight: bold;
        margin-bottom: 0.12rem;
      }
      p {
        font-size: 0.28rem;
        color: #666;
        line-height: 0.4rem;
      }
    }
  }
  .my-swipe {
    width: 100%;
    background: #fff;
    padding-bottom: 0.7rem;
    div {
      height: 4rem;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: auto;
    }
    h1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.44rem;
      font-size: 0.36rem;
      color: #333;
      box-sizing: border-box;
      padding: 0.44rem 0.22rem 0;
      font-weight: bold;
      span {
        font-size: 0.28rem;
        color: #666;
        font-weight: 400;
      }
    }
    ul {
      box-sizing: border-box;
      padding: 0 0.4rem 0 0.22rem;
      li {
        border-bottom: 0.01rem solid #dcdfe6;
        padding: 0.44rem 0;
        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          margin-bottom: 0.2rem;
        }
        a {
          color: #333;
          font-size: 0.28rem;
          &:active {
            color: #108ee9;
          }
        }
        span {
          font-size: 0.24rem;
          color: #999;
        }
      }
    }
  }
  .home_friend {
    box-sizing: border-box;
    padding: 0.2rem 0.22rem;
    section {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    div {
      border: 0.01rem solid #dcdfe6;
      border-radius: 0.1rem;
      width: 30%;
      height: 0.94rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5%;
      box-sizing: border-box;
      margin-bottom: 0.3rem;
      &.noleft {
        margin-left: 0;
      }
      img {
        width: 1.8rem;
        height: auto;
      }
    }
  }
  .home_fr_mo {
    text-align: center;
    font-size: 0.28rem;
    color: #000;
    margin: 0.28rem 0 1rem;
    i {
      margin-left: 0.1rem;
      font-size: 0.22rem;
    }
  }
}
</style>
<style lang="less">
#home {
  video {
    outline: none;
    border: none;
    width: 100% !important;
    //object-fit: fill;
  }
  .vjs-poster {
    background-size: cover;
  }
  .vjs-big-play-button {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    border: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .vjs-icon-placeholder {
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      &::before {
        font-size: 0.4rem;
        line-height: 0.9rem;
      }
    }
  }
  .vjs-control-bar {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue